module.exports = __webpack_public_path__ + "static/media/riverSketch3.008a0860.png";